import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import islandHero from "@/assets/discover/island-panorama-hero.jpg";

const CHIPS = [
  { label: "Taste", to: "/taste-st-kitts" },
  { label: "Heritage", to: "/history-of-st-kitts" },
  { label: "Nature", to: "/nature-of-st-kitts" },
  { label: "Wellness", to: "/caribbean-heritage-longevity-method" },
  { label: "Local Experiences", to: "/local-st-kitts" },
];

const DiscoverIslandFeature = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="relative min-h-[70vh] flex items-center">
        <img
          src={islandHero}
          alt="St. Kitts island panorama"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div
          aria-hidden
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(100deg, hsl(150 35% 8% / 0.88) 0%, hsl(150 35% 8% / 0.6) 55%, hsl(150 35% 8% / 0.2) 100%)",
          }}
        />
        <div className="relative z-10 container mx-auto px-6 py-24 md:py-32" style={{ maxWidth: "1400px" }}>
          <Reveal className="max-w-2xl">
            <p className="font-sans text-[11px] tracking-[0.42em] uppercase text-accent mb-5">
              Discover St. Kitts
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-[hsl(40_33%_96%)] leading-[1.05] mb-6">
              Discover the Island Behind the Method
            </h2>
            <p className="font-sans text-base md:text-lg text-white leading-relaxed mb-10 max-w-xl">
              A deeper look into the people, landscapes, foods and traditions
              shaping Caribbean wellness culture.
            </p>

            <div className="flex flex-wrap gap-3 mb-10">
              {CHIPS.map((c) => (
                <Link
                  key={c.label}
                  to={c.to}
                  className="group inline-flex items-center gap-2 border border-[hsl(40_33%_94%)]/30 text-[hsl(40_33%_96%)] px-5 py-2.5 rounded-full font-sans text-[12px] tracking-[0.18em] uppercase hover:border-accent hover:text-accent hover:bg-[hsl(150_35%_8%)]/30 backdrop-blur-sm transition-all"
                >
                  {c.label}
                </Link>
              ))}
            </div>

            <Link
              to="/discover-st-kitts"
              className="group inline-flex items-center gap-2 bg-accent text-accent-foreground px-8 py-4 rounded-sm font-sans font-semibold text-[11px] uppercase tracking-[0.28em] hover:opacity-90 transition-opacity"
            >
              Enter the Island Archive <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default DiscoverIslandFeature;
